module.exports = __webpack_public_path__ + "media/images/application/template/button-app-store-5c7cea71f16a9ece4fc7d978ba4f40be.png";